import { EditLodgingOptionState, EditLodgingOptionActionTypes, EDIT_LODGING_OPTION_DATA_REQUEST, EDIT_LODGING_OPTION_DATA_SUCCESS, EDIT_LODGING_OPTION_DATA_FAILURE } from "store/reducers/lodgingOption/edit/types";

const defaultState: EditLodgingOptionState = {
  isLoading: false,
  errorMessage: ""
};

export default function editLodgingOption(state = defaultState, action: EditLodgingOptionActionTypes): EditLodgingOptionState {
  switch (action.type) {
    case EDIT_LODGING_OPTION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case EDIT_LODGING_OPTION_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case EDIT_LODGING_OPTION_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};